/*
 * Copyright (c) 2026 Joseph Duggan. All rights reserved.
 */
import colors from './tokens/colors.json' with { type: 'json' };
import spacing from './tokens/spacing.json' with { type: 'json' };
import typography from './tokens/typography.json' with { type: 'json' };
/**
 * Design tokens are the lowest layer of the UI cohesion stack
 * (per docs/DESIGN-PRINCIPLES.md §4).
 *
 * Source values live in JSON. The Style Dictionary compile step
 * lands in Phase 3+ when more than one surface consumes the tokens;
 * for now apps consume the raw exports.
 *
 * Branding note: codebase is `sidekick`, UI is branded `second`.
 * See apps/web/design-reference/uploads/ for the brand brief.
 */
export const tokens = {
    colors,
    spacing,
    typography,
};
const palettesRaw = colors.palettes;
const pairsRaw = typography.pairs;
export const palettes = palettesRaw;
export const typePairs = pairsRaw;
/** Software Neutral — recommended for the app shell. */
export const appPalette = palettesRaw.software;
/** Inter Tight + Fraunces — recommended pair. */
export const appType = pairsRaw.default;
/**
 * CSS custom property string for the given palette. Returned as the body
 * of a `:root { ... }` block so callers can inject it however they want.
 */
export function paletteCssVars(palette) {
    return [
        `--bg: ${palette.bg};`,
        `--bg-alt: ${palette.bgAlt};`,
        `--fg: ${palette.fg};`,
        `--muted: ${palette.muted};`,
        `--rule: ${palette.rule};`,
        `--line: ${palette.line};`,
        `--warm: ${palette.warm};`,
        `--accent: ${palette.accent};`,
        `--chip: ${palette.chip};`,
    ].join('\n');
}
export function typePairCssVars(pair) {
    return [
        `--font-sans: ${pair.sans};`,
        `--font-serif: ${pair.serif};`,
        `--font-mono: ${pair.mono};`,
        `--serif-feat: ${pair.serifFeat};`,
    ].join('\n');
}
//# sourceMappingURL=index.js.map